import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompressPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#F43F3F" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M24 17.778v1.955c0 1.494 0 2.24-.29 2.811-.256.502-.664.91-1.166 1.165-.57.291-1.317.291-2.81.291h-1.956M14.222 8h-1.955c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C8 10.026 8 10.773 8 12.266v1.956M8 24l5-5m0 0H8m5 0v5M24 8l-5 5m0 0h5m-5 0V8"
    />
  </svg>
);
export default SvgCompressPdf;
